import React, { useRef, useEffect, useState } from "react";
import "./MentorDetails.css";
// import FavoriteBorderTwoToneIcon from "@mui/icons-material/FavoriteBorderTwoTone";
// import BookmarkBorderTwoToneIcon from "@mui/icons-material/BookmarkBorderTwoTone";
// import BookmarkTwoToneIcon from "@mui/icons-material/BookmarkTwoTone";
import { useLocation, useSearchParams } from "react-router-dom";
import WorkIcon from "@mui/icons-material/Work";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import SchoolIcon from "@mui/icons-material/School";
import LanguageIcon from "@mui/icons-material/Language";
import MentorPricing from "../MentorPricing/MentorPricing";
import RecentReview from "../RecentReview/RecentReview";
import MentorsTechnicalSkills from "../MentorsTechnicalSkills/MentorsTechnicalSkills";
import dummyProfileImage from "../../../assets/dummy-profile-pic.png";
import { getMentorsById } from "../../../ApiServices/ApiServices";
import { handleError } from "../../../Utils";
import MentorAbout from "./MentorAbout";

const MentorDetails = () => {

  const [mentor, setMentor] = useState(null);
  const [rating, setRating] = useState(0);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const name = searchParams.get("name");
  const hasCalled = useRef(false);

  // Reference for the MentorPricing section
  const pricingRef = useRef(null);

  // Function to scroll to the pricing section
  const scrollToPricing = () => {
    pricingRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if(hasCalled.current) return ;
    hasCalled.current = true;
    document.title = `Codequeue - ${name}`;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    const fetchMentorsData = async () => {
      try {
        const mentor = await getMentorsById(id);
        console.log(mentor)
        setMentor(mentor?.data)
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    };
    fetchMentorsData();
  }, [id]);

  return (
    <div className="mentor-details flex-col">
      <div className="mentor-details-profile card-shadow">
        <div className="upper">
          <div className="mentor-details-image flex">
            <img
              src={mentor?.profileImage?.url || dummyProfileImage}
              alt="img"
            />
          </div>
        </div>
        <div className="middle flex">
          {/* <span>
            <FavoriteBorderTwoToneIcon />
          </span>
          <span className="cursor-pointer">
            <BookmarkBorderTwoToneIcon />
          </span> */}
          {/* Add onClick to trigger scrollToPricing */}
          <span className="cursor-pointer" onClick={scrollToPricing}>
            View Pricing
          </span>
        </div>
        <div className="lower flex">
          <div className="lower-left">
            <h4 className="ml-3 mt-1">{mentor?.name}</h4>
            <div className="flex location-rating-lang">
              <div className="location">
                <PeopleAltIcon className="location-icon" />
                {mentor?.selectedDesignation}
              </div>
              <div className="location">
                {rating}
                <StarPurple500Icon className="location-icon" /> {mentor?.ratting}
                Rating
              </div>
            </div>
            <div className="mentor-detail-bio">{mentor?.heading}</div>
            <div className="flex location-rating-lang">
              <div className="location">
                <FmdGoodIcon className="location-icon" />
                {mentor?.selectedState},{mentor?.selectedCountry}
              </div>
              <div className="location">
                <LanguageIcon className="location-icon" />
                English, {mentor?.selectedLanguage}
              </div>
              {/* <div className="location">
                <PublicIcon className="location-icon" />
                100+ Bookings
              </div> */}
            </div>
          </div>
          <div className="lower-right flex-col">
            <div className="location">
              <WorkIcon className="location-icon" />
              {mentor?.selectedExperience} of experience
            </div>
            <div className="location">
              <MicrosoftIcon className="location-icon" />
              {mentor?.currentCompany}
            </div>
            <div className="location">
              <SchoolIcon className="location-icon" />
              {mentor?.college}
            </div>
          </div>
        </div>
      </div>
      {/* Add ref to MentorPricing section */}
      <div className="mentor-details-skills card-shadow">
        <MentorAbout mentor={mentor} />
      </div>
      <div ref={pricingRef} className="mentor-details-pricing card-shadow">
        <MentorPricing
          id={mentor?._id}
          mentorName={mentor?.name}
          profileImage={mentor?.profileImage?.url}
        />
      </div>
      <div className="mentor-details-skills card-shadow">
        <MentorsTechnicalSkills mentor={mentor} />
      </div>
      <div className="mentor-details-available-slot"></div>
      <div className="mentor-details-testimonials card-shadow">
        <RecentReview id={mentor?._id} setRating={setRating} />
      </div>
    </div>
  );
};

export default MentorDetails;
